import React, { Component } from 'react';
import {PublicClientApplication} from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import {msalConfig,loginRequest,tokenForAPI,tokenForGraph,graphEndPoint,graphRoleEndPoint} from '../../../configuration/clientConfig';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { setAzureUserAcc,loginAction,setAzureMsal,SetHomePath,SetAzureLoginError } from "../actions/index";
import {constants} from '../containers/common/commonExport';
import AuthComponent from './authComp';
import RoutesComponent from './Routes';
import { BrowserRouter } from 'react-router-dom'

const msalAuth = new PublicClientApplication(msalConfig);

    class Msal extends Component {
        constructor(props) {
            
            super(props);
            this.state = {
                isAuthenticated: false,
                path:'/'
            };
        }

        componentWillMount() {
            
            this.props.setAzureMsal(msalAuth);
            msalAuth.handleRedirectPromise().then((response) => 
            {
              if (response) {
                this.makeGraphApiCalls(response);
              } 
            }).catch(error => {
                console.log(error);
                this.props.setError(error.message);
            });
            const currentAccounts = msalAuth.getAllAccounts();
            if (currentAccounts && currentAccounts.length > 0) {
                const tokenRequest = {
                    account : currentAccounts[0],
                    ...tokenForGraph
                }
                msalAuth.acquireTokenSilent(tokenRequest).then((accessTokenResponse) =>  {
                    this.makeGraphApiCalls(accessTokenResponse);
                }).catch((error) => {
                    console.log(error);
                    if (error.errorMessage.indexOf("interaction_required") !== -1) {
                        msalAuth.acquireTokenRedirect(tokenRequest);
                    }
                });
                
            }
            else{
                msalAuth.loginRedirect(loginRequest);
                return;
            }
            
        }
        makeGraphApiCalls(response){
            try{
                const account = response.account;
                const token = response.accessToken;
                this.callMSGraph(graphEndPoint,token,(response) => {
                    let empName = response.userPrincipalName;
                    let empId = response.employeeId;

                    this.callMSGraph(graphRoleEndPoint,token,(res) =>{
                        if(res.value){
                            const tokenRequest = {...tokenForAPI,account:account};
                            msalAuth.acquireTokenSilent(tokenRequest).then((apiTokenResp) =>  {
                                const assignedGroups = res.value.filter(grp => {return constants.GROUPS.includes(grp.displayName)});
                                let fraGroup = assignedGroups.find((item)=>{return item.displayName=='FRA HOS' });                
                                let adminGroup =  assignedGroups.find((item)=>{return item.displayName=='HOS Management' });                
                                let role = !adminGroup && fraGroup ? constants.roles.FRA_ROLE : adminGroup ? constants.roles.ADMIN_ROLE : constants.roles.EMPLOYEE_ROLE; 
                        
                                let menus = [ { MenuType: 1 }, { MenuType: 2 }, { MenuType: 3 } ]
                                let authObj = {
                                    success:true,authenticated:true,id_token:token,name:empName,employeeID:empId,
                                    role:role,activeMenus: menus,api_token:apiTokenResp.accessToken
                                };  
                                this.props.setADUserAcc(account.username);
                                this.updateLoginState(authObj);
                                
                            }).catch((error) => {
                                console.log(error);
                                this.props.setError(error.message);
                                throw error;
                            });
                                 
                        }
                    });
                });
            }
            catch(error){
                this.props.setError(error.message);
                console.log(error);
            }
        }
        updateLoginState = (res) =>{
            try{
                var user = {...res};
                if(user.success == false){               
                   // this.props.onLogin('LoginError', user.errMsg); // error action
                } else {
                    this.props.onLogin('LoginSuccess', user); // login success action
                    let componentPath =  constants.routes.defaultEmpRoute; // component for Employee
                    switch (user.role) {
                        case constants.roles.ADMIN_ROLE:
                            componentPath = constants.routes.defaultAdminRoute; // default component to open for Admin                                                   
                            break;
                        case constants.roles.FRA_ROLE:  
                            componentPath= constants.routes.defaultFRARoute                                                                    
                            break;                    
                        default:
                            componentPath = constants.routes.defaultEmpHosRoute //: constants.routes.defaultEmpRoute; // component for Employee
                    }
                    this.props.setPath(componentPath);                  
                    this.setState({isAuthenticated:true,path:componentPath});
                }
            }
            catch(err){
                throw err;
            }
            
        }
        callMSGraph(graphEndPoint,token, callback) {
            const headers = new Headers();
            const bearer = `Bearer ${token}`;
            headers.append("Authorization", bearer);
            const options = {
                method: "GET",
                headers: headers
            };
            fetch(graphEndPoint, options)
            .then(response => response.json())
            .then(response => callback(response))
            .catch(error => {throw error} );
        };
      
        render() {        
            
            if (this.state.isAuthenticated) {              
                return(
                    <MsalProvider instance={msalAuth}>
                        <BrowserRouter >
                        <RoutesComponent {...this.props} isAuthenticated = {this.state.isAuthenticated}  />
                        </BrowserRouter>
                </MsalProvider>                      
                )               
            }
            if (this.props.isAzureError) {
                return <div className='authHead error'>{'Azure authetication failed: '+this.props.azureErrMsg}</div>;
            }
            return <AuthComponent />
        }
    };
    function mapStateToProps(state) {       
        return { 
            loggedIn:state.authenticated,
            isAzureError:state.isAzureError,
            azureErrMsg:state.azureErrMsg
        };
    }


    function matchDispatchToProps(dispatch) {
        return bindActionCreators(
        {
            onLogin:loginAction,
            setADUserAcc:setAzureUserAcc,
            setAzureMsal:setAzureMsal,
            setPath:SetHomePath,
            setError:SetAzureLoginError
        }, dispatch);
    }
    
    export default connect(mapStateToProps, matchDispatchToProps)(Msal);

